module.exports = __webpack_public_path__ + "static/img/banner2.c844711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/banner2.jpg
// module id = EcXd
// module chunks = 1